import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDebounce } from 'usehooks-ts';
import {
  DebounceTimer,
  LoadingStatus,
  ToastThemes,
} from '../../../../constants/common';
import TryAgain from '../../../molecules/ErrorState/error.component';
import CircularLoader from '../../../../atoms/CircularLoader/circular-loader';
import { Box } from '@mui/material';
import ListView from '../../../../atoms/DataList/ListView';
import AllUserMultiselectModalMap from './all-user-ats-modal-map';
import { OnboardingServices } from '../../../../services/onboarding';
import { showToast } from '../../../../utils/common.util';
import { getFormattedValues } from '../../../../utils/formatter';

const AllUserMultiselectCandidate = () => {
  const { currentUserRoleId, isMobile } = useSelector((state) => state.main);
  const [checkedItems, setCheckedItems] = useState([]);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(-1);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  // const [selectedDate, setSelectedDate] = useState([fy.start, fy.end]);
  const searchQuery = searchParams?.get('q');
  const debouncedVal = useDebounce(searchQuery, DebounceTimer);

  useEffect(async () => {
    if (currentUserRoleId) {
      setLoading(LoadingStatus.Loading);
      await new OnboardingServices()
        .getATSCandidate(
          currentUserRoleId,
          searchQuery
        )
        .then((res) => {
          setLoading(LoadingStatus.Success);
          setList(res);
        })
        .catch((err) => {
          setLoading(LoadingStatus.Failure);
          showToast(err?.response?.data?.message, ToastThemes.error);
          throw err?.response?.data?.message;
        });
    }
  }, [currentUserRoleId, debouncedVal]);

  useEffect(() => {
    setCheckedItems([]);
  }, [list]);

  // const handleAddClick = () => {
  //     navigate('create');
  //   };

  const rowData = list?.map((items) => {
    const { id, name, designation, selectedOn } = items;
    return {
      user: name,
      offer: 'NO',
      des: designation,
      check: '',
      date: selectedOn ? getFormattedValues('YYYY-MM-DD', selectedOn) : '',
      status: 'Completed',
      // action: (
      //   <IconButton
      //     onClick={() => {
      //       navigate({ pathname: `${id}` });
      //     }}
      //   >
      //     <InfoOutlined sx={{ color: 'primary.main80' }} />
      //   </IconButton>
      // ),
      id: {
        value: id,
        hide: true,
      },
    };
  });

  // const isDisabledReset = () => {
  //   return selectedDate[0].isSame(fy.start) && selectedDate[1].isSame(fy.end);
  // };

  // const resetFilters = () => {
  //   setSelectedDate([fy.start, fy.end]);
  // };

  if (loading === LoadingStatus.Failure) {
    return <TryAgain />;
  }
  return (
    <>
      <CircularLoader show={loading === LoadingStatus.Loading} />
      <Box sx={{ backgroundColor: 'white' }}>
        <Box display="flex" justifyContent="flex-end" gap={2} mb={1} p={2}>
          {/* <DateRangePro
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
          />
          <Button
            startIcon={<SettingsBackupRestoreOutlined />}
            sx={{ textTransform: 'capitalize', mt: -1.5 }}
            disabled={isDisabledReset()}
            onClick={resetFilters}
          >
            Clear
          </Button> */}
          <Box pr={1}>
            <AllUserMultiselectModalMap
              checkedItems={checkedItems}
              currentUserRoleId={currentUserRoleId}
              searchQuery={searchQuery}
              // selectedDate={selectedDate}
              setList={setList}
            />
          </Box>
        </Box>
        <ListView
          headCells={[
            {
              id: 'user',
              label: 'Candidate',
            },
            {
              id: 'offer',
              label: 'Offer Sent',
            },
            {
              id: 'des',
              label: 'Designation',
            },
            {
              id: 'check',
              label: 'Checklist',
            },
            {
              id: 'date',
              label: 'Selected On',
              dataType: 'date',
              dateFormat: 'YYYY-MM-DD',
            },
            {
              id: 'status',
              label: 'Status',
            },
          ]}
          rowsData={rowData || []}
          showSerialNo={!isMobile}
          showCheckbox={true}
          setCheckedItems={setCheckedItems}
          checkedItems={checkedItems}
          allowSelectAll={true}
          // onAddClick={handleAddClick}
          showAddIcon={false}
        />
      </Box>
    </>
  );
};

export default AllUserMultiselectCandidate;
